import React, { FC } from 'react';
import { FileThumbnail } from '../../../../components/common/Thumbnails';
import { MediaManagerSDKFile } from '../../../../utils/media-manager-sdk';
import { IOuter } from '../ItemDemonstration.types';

export const Labeled: FC<IOuter> = ({ item, className, saveRef }) => (
  <div className={className} ref={saveRef}>
    <FileThumbnail
      file={item as MediaManagerSDKFile}
      width={150}
      height={150}
      dataHook="expanded-view-file-demonstration"
    />
  </div>
);
